import React, { memo, useCallback } from 'react';
import { Button, Tooltip } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTypedSelector } from '@hooks';
import './HeaderBreadcrumbs.less';
import { useAuth } from '@hooks/useAuth';
import DropdownAssetVersions from '@components/MediaViewerHeader/components/DropdownAssetVersions';
import { ReactComponent as ArrowLeftSvg } from '@assets/icons/arrow-left-without-line.svg';
import { UXP_CLOSE_EMBEDDED_MEDIA_VIEWER } from '@helpers/uxpEmbeddedMediaViewer';

function HeaderEmbeddedMediaTitle() {
  const navigate = useNavigate();
  const selectedVersion = useTypedSelector(
    ({ mediaViewer }) => mediaViewer.selectedVersion
  );
  const { user } = useAuth();
  const isInternal = user?.type === 'internal';

  const onBack = useCallback(() => {
    const { uxpHost } = window as unknown as {
      uxpHost?: { postMessage: (msg: object) => void };
    };

    if (uxpHost) {
      uxpHost.postMessage({ type: UXP_CLOSE_EMBEDDED_MEDIA_VIEWER });
      return;
    }
    navigate(-1);
  }, [navigate]);

  if (!selectedVersion) return null;
  const label = `${selectedVersion.name}.${selectedVersion.extension}`;

  return (
    <div className="media_viewer_breadcrumbs media_viewer_breadcrumbs--embedded-title">
      <div className="media_viewer_breadcrumbs-wr">
        <Button
          className="media_viewer_btn b-only-icon tour-paused-media-viewer"
          onClick={onBack}
        >
          <ArrowLeftSvg />
        </Button>

        <div className="media_viewer_breadcrumbs-navigation">
          <div className="media_viewer_breadcrumbs-item">
            <Tooltip
              title={label}
              overlayClassName="toggle_favorite_overlay  toggle_favorite_overlay--small"
              overlayInnerStyle={{ position: 'relative', top: '-30px' }}
            >
              <span className="item-name">{label}</span>
            </Tooltip>
          </div>
          <DropdownAssetVersions external={!isInternal} />
        </div>
      </div>
    </div>
  );
}

export default memo(HeaderEmbeddedMediaTitle);
